import { DataField, Form, onFieldReact } from '@eastcoal/formily/exports/core'

import { FeeMethod } from '@eastcoal/shared/enums/FeeMethod'

import { SERVICE_FEE_FIELD } from '../../constants/field'

/**
 * “预收额”联动逻辑
 */
const serviceFeeAdvanceAmountField = 'serviceFeeAdvanceAmount'

const clearValue = (_: unknown, form: Form) => {
  const { serviceFeeMethod = 0 } = form.values
  const clearable = serviceFeeMethod < FeeMethod.PROPORTIONAL
  const serviceFeeField = form
    .query(serviceFeeAdvanceAmountField)
    .take() as DataField
  if (clearable) serviceFeeField?.onInput(undefined)
}
const updateState = (_: unknown, form: Form) => {
  const { serviceFeeMethod = 0 } = form.values
  const editable = serviceFeeMethod >= FeeMethod.PROPORTIONAL

  form.setFieldState(serviceFeeAdvanceAmountField, {
    disabled: !editable,
    required: editable
  })
}

export const serviceFeeAdvanceAmountEffect = () => {
  onFieldReact(SERVICE_FEE_FIELD, updateState)
  onFieldReact(SERVICE_FEE_FIELD, clearValue)
}
